module.exports = __webpack_public_path__ + "static/media/moduleCloseButton.7515b2f2.svg";